var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPreviewFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.321,
    height: 17.797,
    viewBox: "0 0 16.321 17.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "preview-svgrepo-com",
    transform: "translate(-20.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M250.071,307.349q.015-.039.03-.077Q250.086,307.31,250.071,307.349Z",
    transform: "translate(-221.425 -296.092)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M288.122,394.6l-.044-.017Z",
    transform: "translate(-258.05 -380.23)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M251.334,304.6l.029-.063Z",
    transform: "translate(-222.643 -293.452)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M299.521,397.946l-.074-.013Z",
    transform: "translate(-269.005 -383.455)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M290.706,395.56l-.056-.019Z",
    transform: "translate(-260.528 -381.15)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M248.985,310.145c.01-.03.02-.06.03-.09C249,310.085,248.995,310.115,248.985,310.145Z",
    transform: "translate(-220.379 -298.774)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M296.513,397.279l-.065-.015Z",
    transform: "translate(-266.115 -382.81)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M293.572,396.481l-.06-.017Z",
    transform: "translate(-263.286 -382.039)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M281.484,391.567l-.029-.015Z",
    transform: "translate(-251.668 -377.306)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M279.006,390.189l-.024-.014Z",
    transform: "translate(-249.285 -375.979)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M302.61,398.482l.048,0c-.054,0-.108-.01-.161-.018Z",
    transform: "translate(-271.944 -383.97)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M248.093,313.492c.007-.026.014-.053.022-.079Q248.1,313.452,248.093,313.492Z",
    transform: "translate(-219.519 -302.01)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M259.479,372.949l-.01-.013Z",
    transform: "translate(-230.481 -359.367)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M284.074,392.865l-.031-.014Z",
    transform: "translate(-254.161 -378.557)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M246.71,319.853q.007-.042.015-.084Q246.717,319.811,246.71,319.853Z",
    transform: "translate(-218.187 -308.134)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M247.269,316.34q.011-.051.024-.1Q247.28,316.288,247.269,316.34Z",
    transform: "translate(-218.725 -304.732)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M245.976,326.344q0-.047.007-.094C245.98,326.281,245.978,326.312,245.976,326.344Z",
    transform: "translate(-217.479 -314.38)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M246.216,322.927c0-.036.008-.072.014-.107C246.224,322.855,246.22,322.891,246.216,322.927Z",
    transform: "translate(-217.711 -311.074)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M276.709,388.786l-.015-.009Z",
    transform: "translate(-247.08 -374.632)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M309.65,399.139l-.1,0Z",
    transform: "translate(-278.738 -384.614)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M252.553,302.5l-.021.042Z",
    transform: "translate(-223.797 -291.494)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M302.653,266.553l.091-.012Z",
    transform: "translate(-272.094 -256.843)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M245.862,329.611c0,.035,0,.07,0,.105C245.859,329.681,245.86,329.646,245.862,329.611Z",
    transform: "translate(-217.367 -317.618)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M305.862,266.256l.1-.008Z",
    transform: "translate(-275.187 -256.561)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M190.285,303.591h.567a3.864,3.864,0,0,1,.159-1.092h-.725Z",
    transform: "translate(-163.815 -291.494)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M190.285,233.592h1.529a3.886,3.886,0,0,1,1.595-1.092h-3.124Z",
    transform: "translate(-163.815 -224.041)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M264.87,379.178l0,0,.016.016.016.016.017.016Z",
    transform: "translate(-235.686 -365.382)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M309.445,266.142l-.111,0Z",
    transform: "translate(-278.532 -256.459)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M193.923,7V8.312a3.867,3.867,0,0,1,2.547.33V4.065h-4.065V0h-2.121V7Z",
    transform: "translate(-163.815)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M299.584,266.982l.086-.015Z",
    transform: "translate(-269.137 -257.254)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M290.417,269.572l.035-.012Z",
    transform: "translate(-260.303 -259.752)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M191.265,372.794q-.073-.144-.133-.294h-.848v3h6.185v-.99a3.872,3.872,0,0,1-5.2-1.718Z",
    transform: "translate(-163.814 -358.947)",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M296.229,267.619l.084-.019Z",
    transform: "translate(-265.904 -257.864)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M293.634,268.484l.049-.014Z",
    transform: "translate(-263.403 -258.702)",
    fill: "#46f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M23.181,13.553V12.1h4.137V11.006H23.181V9.551h4.137V8.459H23.181V7h4.137V0H20.285V16.555h7.033v-3Z",
    fill: "#f26122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M252.634,4.065,248.569,0V4.065Z",
    transform: "translate(-219.978)",
    fill: "#f6a07b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M90.285,192.5v1.455h6.762a3.836,3.836,0,0,1,.515-.147V192.5Z",
    transform: "translate(-67.453 -185.496)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M245.856,332.5s0,0,0,.006c0,.035,0,.069,0,.1,0-.034,0-.069,0-.1C245.856,332.5,245.856,332.5,245.856,332.5Z",
    transform: "translate(-217.364 -320.402)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M251.566,359.592c-.01-.021-.019-.041-.028-.062C251.547,359.551,251.556,359.572,251.566,359.592Z",
    transform: "translate(-222.839 -346.449)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M249.038,352.985c-.007-.02-.014-.04-.02-.06C249.024,352.945,249.031,352.965,249.038,352.985Z",
    transform: "translate(-220.411 -340.084)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M248.157,349.995c-.006-.021-.012-.042-.018-.063C248.145,349.953,248.151,349.974,248.157,349.995Z",
    transform: "translate(-219.564 -337.2)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M257.738,370.553l-.019-.026Z",
    transform: "translate(-228.795 -357.046)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M254.549,365.492l-.021-.036Z",
    transform: "translate(-225.72 -352.159)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M247.4,346.9c-.006-.022-.011-.045-.016-.067C247.394,346.86,247.4,346.882,247.4,346.9Z",
    transform: "translate(-218.841 -334.218)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M256.092,368.068l-.02-.032Z",
    transform: "translate(-227.208 -354.645)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M253.109,362.82l-.021-.04Z",
    transform: "translate(-224.333 -349.581)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M250.049,355.9c-.008-.02-.016-.04-.024-.06C250.032,355.862,250.041,355.882,250.049,355.9Z",
    transform: "translate(-221.381 -342.895)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M246.1,338.153c0,.016,0,.032,0,.048,0,.038.009.076.015.114C246.11,338.261,246.1,338.206,246.1,338.153Z",
    transform: "translate(-217.599 -325.85)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M246.776,343.639c-.005-.025-.009-.051-.014-.077C246.766,343.588,246.771,343.613,246.776,343.639Z",
    transform: "translate(-218.237 -331.062)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M90.285,332.5v1.455h4.486a3.854,3.854,0,0,1-.281-1.449s0,0,0-.006Z",
    transform: "translate(-67.453 -320.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M253.138,301.4l-.021.04Z",
    transform: "translate(-224.361 -290.434)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M279.672,274.742h0Z",
    transform: "translate(-249.949 -264.745)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M281.69,273.652h0Z",
    transform: "translate(-251.894 -263.694)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M263.806,286.8l.018-.018Z",
    transform: "translate(-234.661 -276.347)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M273.9,278.285l.009-.007Z",
    transform: "translate(-244.385 -268.153)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M288.736,270.472h0Z",
    transform: "translate(-258.684 -260.63)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M268.611,282.324l.014-.012Z",
    transform: "translate(-239.291 -272.04)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M284.972,271.908l.014-.006Z",
    transform: "translate(-255.057 -262.009)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M262.047,288.639l.02-.023Z",
    transform: "translate(-232.966 -278.115)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M257.858,293.667l.026-.036Z",
    transform: "translate(-228.929 -282.948)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M254.3,299.016l.028-.048Z",
    transform: "translate(-225.497 -288.09)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M255.739,295.913q.023-.037.047-.072Q255.762,295.877,255.739,295.913Z",
    transform: "translate(-226.887 -285.077)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M259.506,291.592l.023-.029Z",
    transform: "translate(-230.517 -280.955)",
    fill: "#005ece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M90.285,262.5v1.455h4.364a3.874,3.874,0,0,1,.8-1.455Z",
    transform: "translate(-67.453 -252.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M373.24,392.5a3.908,3.908,0,0,1-1.029,1.029l2.487,2.487,1.029-1.029Z",
    transform: "translate(-339.122 -378.215)",
    fill: "#f6a07b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M314.328,267.115q-.035-.047-.072-.092a2.417,2.417,0,0,0-1.867-.882v4.841a2.418,2.418,0,0,0,1.939-3.868Z",
    transform: "translate(-281.476 -256.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M248.278,266.142l-.111,0h-.022l-.1.008-.026,0-.091.012-.025,0-.086.015-.038.008-.084.02-.046.012-.049.014-.082.026-.035.012-.058.021h0q-.062.024-.123.051l-.014.006q-.06.027-.118.057h0l-.071.038h0q-.1.059-.2.127l-.009.007q-.093.066-.179.14l-.014.012q-.082.072-.157.151l-.018.018-.044.048-.02.023q-.036.041-.07.084l-.023.029-.034.046-.026.036-.031.044-.047.073-.025.041-.028.048-.022.04-.021.04-.021.042-.015.032-.029.063-.016.037q-.016.038-.03.077l-.009.024c-.011.03-.021.06-.03.09l-.01.032q-.012.039-.022.079l-.006.024q-.013.05-.024.1l-.005.027q-.008.042-.015.084l0,.027q-.008.053-.014.107c0,.006,0,.012,0,.018q0,.047-.007.094c0,.01,0,.019,0,.029,0,.035,0,.07,0,.105,0,0,0,0,0,.006,0,.035,0,.069,0,.1s0,.063.006.094c0,.055.01.109.018.163,0,.012,0,.023.006.035s.009.051.014.077l.009.043q.007.034.016.067l.012.045q.009.032.018.063l.014.046c.006.02.013.04.02.06l.016.046c.007.02.016.04.024.06s.021.05.031.074.018.042.028.062l.028.056.021.04.032.057.021.036.035.058.02.032.039.059.019.026.045.061.01.013a2.465,2.465,0,0,0,.186.214l.052.051a2.444,2.444,0,0,0,.378.3l.015.009.068.041.024.014.066.036.029.015.065.032.031.014q.057.026.116.049l.044.017.05.017.056.019.048.015.06.017.047.012.065.015.044.009.074.013.037.006c.053.008.107.014.161.018l.1.006.1,0Z",
    transform: "translate(-217.365 -256.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M212.938,232.193a3.868,3.868,0,0,0-.057-4.435,3.9,3.9,0,0,0-1.406-1.2,3.865,3.865,0,0,0-3.977.3,3.894,3.894,0,0,0-1.483,2.068,3.864,3.864,0,0,0-.159,1.092s0,0,0,.006a3.855,3.855,0,0,0,.281,1.449q.061.15.133.294a3.875,3.875,0,0,0,6.667.434Zm-3.206.244-.1,0-.1-.006-.048,0-.113-.014-.037-.006-.074-.013-.044-.009-.065-.015-.047-.012-.06-.017-.048-.015-.056-.019-.05-.017-.044-.017q-.059-.023-.116-.049l-.031-.014-.065-.032-.029-.015-.066-.036-.024-.014-.068-.041-.015-.009a2.443,2.443,0,0,1-.378-.3l-.018-.017-.016-.016-.016-.016,0,0a2.447,2.447,0,0,1-.186-.214l-.01-.013-.045-.061-.019-.026-.039-.059-.02-.032-.035-.058-.021-.036-.032-.057-.021-.04-.028-.056c-.01-.021-.019-.042-.028-.062s-.021-.049-.031-.074-.016-.04-.024-.06l-.016-.046c-.007-.02-.014-.04-.02-.06l-.014-.046c-.006-.021-.012-.042-.018-.063l-.012-.045c-.006-.022-.011-.045-.016-.067s-.006-.028-.009-.043-.009-.051-.014-.077,0-.023-.006-.035c-.006-.038-.011-.076-.015-.114,0-.016,0-.032,0-.048,0-.033,0-.064-.006-.1s0-.069,0-.1c0,0,0,0,0-.006,0-.035,0-.07,0-.105,0-.01,0-.019,0-.029q0-.047.007-.094l0-.018c0-.036.008-.072.014-.107l0-.027q.007-.042.015-.084l.005-.027q.011-.051.023-.1l.006-.024q.011-.04.022-.079l.01-.032q.014-.045.03-.09l.009-.024q.015-.039.03-.077l.016-.036.029-.063.015-.032.021-.042.021-.04.022-.04.028-.048.025-.041.046-.072.031-.044.026-.036.034-.046.023-.029q.034-.043.07-.084l.02-.023.044-.048.018-.018q.075-.079.157-.151l.014-.012q.086-.074.179-.14l.009-.007q.1-.068.2-.127h0l.071-.038h0q.058-.03.118-.057l.014-.006q.061-.027.123-.051h0l.058-.021.035-.012.082-.026.049-.014.046-.012.084-.02.038-.008.086-.015.025,0,.091-.012.026,0,.1-.008h.022l.111,0a2.417,2.417,0,0,1,1.867.882q.037.045.072.091a2.42,2.42,0,0,1-1.939,3.868Z",
    transform: "translate(-178.819 -217.912)",
    fill: "#f6a07b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPreviewFile);
export default __webpack_public_path__ + "static/media/ic-preview-file.622f3506.svg";
export { ForwardRef as ReactComponent };